import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { HomeComponent } from './home/home.component';
import { CategoryComponent } from './category/category.component';
import { QAndAComponent } from './q-and-a/q-and-a.component';

const routes: Routes = [
  // Redirects
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: HomeComponent,
    pathMatch: 'full',
  },
  {
    path: 'category/:categoryId',
    component: CategoryComponent,
    pathMatch: 'full',
  },
  {
    path: 'q-and-a/:questionId/:subId',
    component: QAndAComponent,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    BrowserModule,
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
